import axios from 'axios';
import Utils from 'Helpers/utils';
import constants from 'Helpers/constants';

export default {
    namespaced: true,
    state: {
        email: '',
        userName: '',
        newPassword: '', //New Password
        confirmPassword: '', //Confirm New Password
        password: '', //current password
        user: null,
        token: null,
        balance: {
            credit: 0,
            balance: 0,
            exposure: 0,
            credit_limit: 0,
            bet_balance: 0,
            deposit: 0,
        },
    },
    mutations: {
        setPassword(state, password) {
            state.password = password;
        },

        setConfirmPassword(state, confirmPassword) {
            state.confirmPassword = confirmPassword;
        },

        setNewPassword(state, newPassword) {
            state.newPassword = newPassword;
        },

        setBalance(state, balance) {
            state.balance = Object.assign(state.balance, balance);
        },
    },
    getters: {
        getEmail(state) {
            return state.email;
        },

        getUserName(state) {
            return state.userName;
        },

        getPassword(state) {
            return state.password;
        },

        getConfirmPassword(state) {
            return state.confirmPassword;
        },

        getNewPassword(state) {
            return state.newPassword;
        },

        getUser(state) {
            return state.user;
        },

        getToken(state) {
            return state.token;
        },

        getBalance(state) {
            return state.balance;
        },
    },
    actions: {
        updateUserCredit(context, balance) {
            context.state.balance = Object.assign(context.state.balance, balance);
            // return axios.post('/api/toolUser/updateUserCredit', {
            //     credit: balance.credit,
            // });
            context.dispatch(
                'sendObj',
                {
                    event: 'updateUserCredit',
                    data: {
                        credit: balance.credit,
                    },
                },
                {
                    root: true,
                }
            );
        },
        changePassword(context, params) {
            return axios.get('/api/toolUser/changePassword', { params }).then((response) => {
                return Promise.resolve(response);
            });
        },

        setTimeZone(context, params) {
            return axios.get('/api/toolUser/changeTimeZone', { params }).then((response) => {
                return Promise.resolve(response);
            });
        },

        changeSettings(context, params) {
            return axios.post('/api/toolUser/changeSettings', params).then((response) => {
                return Promise.resolve(response);
            });
        },

        checkDocuments() {
            return axios.get('/api/toolUser/checkDocuments').then((response) => {
                return Promise.resolve(response);
            });
        },

        uploadDocuments(context, params) {
            return axios
                .post('/api/toolUser/uploadDocuments', params, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },

        storeAuth(context, data) {
            if (Utils.getPlatform() === constants.PLATFORM_TRADEBALL) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
            }
            context.state.token = data.token;
            context.state.user = data.user;
        },

        restoreAuth(context) {
            if (localStorage.getItem('token') && localStorage.getItem('user')) {
                context.state.token = localStorage.getItem('token') === 'null' ? null : localStorage.getItem('token');
                context.state.user = JSON.parse(localStorage.getItem('user'));
            }
        },
    },
};
